export const styles = (theme) => ({
  filterButton: {
    paddingTop: theme.spacing(2),
    textAlign: 'right'
  }
})
